import React, { useRef } from "react";
import { BadgeCheck, Scale, RefreshCw, ArrowUpRight } from "lucide-react";
import { services } from "../mock";

const iconMap = { "badge-check": BadgeCheck, scale: Scale, "refresh-cw": RefreshCw };

function TiltCard({ children }) {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current; if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `rotateY(${x * 8}deg) rotateX(${-y * 8}deg) translateY(-6px)`;
  };
  const onLeave = () => { if (ref.current) ref.current.style.transform = ""; };
  return (
    <div className="parallax-wrap">
      <div ref={ref} onMouseMove={onMove} onMouseLeave={onLeave} className="tilt-card">
        {children}
      </div>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" className="section-pad relative" style={{ background: "linear-gradient(180deg, #030524 0%, #070B5F 100%)" }}>
      <div className="orb" style={{ width: 420, height: 420, background: "#6BA82E", top: 40, left: -140, opacity: 0.25 }} />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="max-w-2xl reveal">
          <span className="gold-bar" />
          <div className="text-xs uppercase tracking-[0.28em] font-semibold mt-3" style={{ color: "#8DC63F" }}>Our Services</div>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-3 leading-tight text-white">
            Home loans that fit your <span className="text-gold-grad">life</span>.
          </h2>
          <p className="mt-4 text-white/70 text-lg leading-relaxed">
            Whether you're buying your first home, refinancing, or building an investment portfolio,
            we have a program that works for you.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-7">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <TiltCard key={s.id}>
                <div className="reveal glass rounded-3xl p-8 shadow-3d h-full" style={{ transitionDelay: `${i * 80}ms` }}>
                  <div className="tilt-inner">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-5" style={{ background: "linear-gradient(135deg, #8DC63F 0%, #6BA82E 100%)", boxShadow: "0 8px 20px -6px rgba(141,198,63,0.5)" }}>
                      <Icon size={24} style={{ color: "#070B5F" }} />
                    </div>
                    <div className="text-xs uppercase tracking-widest text-slate-500">{s.kicker}</div>
                    <h3 className="font-serif text-2xl font-semibold mt-2" style={{ color: "#070B5F" }}>{s.title}</h3>
                    <p className="mt-3 text-slate-600 leading-relaxed">{s.description}</p>
                    <a href="#contact" className="inline-flex items-center gap-1.5 mt-5 font-semibold text-sm" style={{ color: "#070B5F" }}>
                      Learn more <ArrowUpRight size={16} />
                    </a>
                  </div>
                </div>
              </TiltCard>
            );
          })}
        </div>
      </div>
    </section>
  );
}
